import { PAGE_SIZE_OPTIONS } from '../../constants/pagination';

interface PaginationProps {
  page: number;
  size: number;
  total: number;
  onPageChange: (page: number) => void;
  onSizeChange: (size: number) => void;
}

/**
 * Previous/Next pager with a rows-per-page selector, driven by the server's `page`, `size` and `total`.
 * @param {PaginationProps} props - current page, page size, total row count and change handlers
 */
export const Pagination = ({ page, size, total, onPageChange, onSizeChange }: PaginationProps) => {
  const totalPages = Math.max(1, Math.ceil(total / size));

  return (
    <div data-testid="pagination" className="my-4 flex flex-wrap items-center justify-center gap-4">
      {totalPages > 1 && (
        <div className="flex items-center gap-2">
          <button
            data-testid="pagination-prev"
            onClick={() => onPageChange(Math.max(1, page - 1))}
            disabled={page <= 1}
            className="px-4 py-2 border rounded-lg disabled:opacity-50"
          >
            Previous
          </button>
          <span className="px-4 py-2 text-sm text-[#555]">
            Page {page} of {totalPages}
          </span>
          <button
            data-testid="pagination-next"
            onClick={() => onPageChange(Math.min(totalPages, page + 1))}
            disabled={page >= totalPages}
            className="px-4 py-2 border rounded-lg disabled:opacity-50"
          >
            Next
          </button>
        </div>
      )}

      <label className="flex items-center gap-2 text-sm text-[#555]">
        Rows per page
        <select
          value={size}
          data-testid="pagination-size"
          onChange={e => onSizeChange(Number(e.target.value))}
          className="rounded-md border border-[#eaeaea] px-2 py-1"
        >
          {PAGE_SIZE_OPTIONS.map(option => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      </label>
    </div>
  );
};
